import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { UNSUBSCRIBE_API_PREFIX } from '../api/unsubscribe-api'

export const useUnsubscribe = () => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation({
    method: RequestMethodsEnum.delete,
  })
  return {
    unsubscribeFromAllMarketingEmails: async (slug: string, messageId: string) => {
      try {
        await fetcher(`${UNSUBSCRIBE_API_PREFIX}/marketing-emails/${slug}/${messageId}/all`)
      } catch (e) {
        throw e
      }
    },

    unsubscribeFromCampaign: async (slug: string, messageId: string, campaignId: string) => {
      try {
        await fetcher(
          `${UNSUBSCRIBE_API_PREFIX}/marketing-emails/${slug}/${messageId}/campaign/${campaignId}`,
        )
      } catch (e) {
        throw e
      }
    },

    unsubscribeFromAutomationRule: async (recipientEmailAddress: string, id: string) => {
      try {
        await fetcher(`${UNSUBSCRIBE_API_PREFIX}/automation-rule/${recipientEmailAddress}/${id}`)
      } catch (e) {
        throw e
      }
    },

    unsubscribeFromTransactionalEmail: async (slug: string) => {
      try {
        await fetcher(`${UNSUBSCRIBE_API_PREFIX}/transactional-emails/${slug}`)
      } catch (e) {
        throw e
      }
    },

    isFetching: isFetching,
  }
}
